import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TrackingScreenNamesEnum } from '../../../tracking/tracking.data';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import { IRouter } from 'i2g-ng-ui';

@Injectable()
export class LoginBuilder {
  constructor(
    private _translateService: TranslateService,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder
  ) {}

  buildRegisterRoute(): IRouter {
    return {
      label: this._translateService.instant('ACTION.SIGN_UP'),
      route: ['/register'],
      trackingAction: this._trackingActionBuilder.buildButtonTapped(
        'sign_up',
        TrackingScreenNamesEnum.account_sign_in
      ),
    };
  }
}
